var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32812 14.2334H17.4948",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32812 18.9004H14.4381",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6615 7.00065H16.3281C18.6615 7.00065 18.6615 5.83398 18.6615 4.66732C18.6615 2.33398 17.4948 2.33398 16.3281 2.33398H11.6615C10.4948 2.33398 9.32812 2.33398 9.32812 4.66732C9.32812 7.00065 10.4948 7.00065 11.6615 7.00065Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 4.69043C22.5517 4.90043 24.5 6.33543 24.5 11.6671V18.6671C24.5 23.3338 23.3333 25.6671 17.5 25.6671H10.5C4.66667 25.6671 3.5 23.3338 3.5 18.6671V11.6671C3.5 6.3471 5.44833 4.90043 9.33333 4.69043",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTextIcon);
export default __webpack_public_path__ + "static/media/clipboard-text-icon.732e0d6bbba6445cf009cdd3245a84bd.svg";
export { ForwardRef as ReactComponent };